import Remove from "@mui/icons-material/Remove";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import UserEntityMemberInvitation from "legal-entities/invitations/member-invitations/email-based/user-entity-member-invitation";

const InvitationsTable = styled("div")(({ theme }) => ({
  padding: theme.spacing(1),
  position: "relative",
  width: "100%",
}));

const InvitationsTableTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));
const NoRowsPlaceholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: "1.3em",
}));

type UserEntityMemberInvitationsTableProps = {
  invitations: UserEntityMemberInvitation[];
};

export default function UserEntityMemberInvitationsTable(props: Readonly<UserEntityMemberInvitationsTableProps>) {
  const { invitations } = props;

  return (
    <InvitationsTable>
      <InvitationsTableTitle variant="h6">Email Invitations</InvitationsTableTitle>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">Id</TableCell>
            <TableCell align="left">Email Address</TableCell>
            <TableCell align="left">Entity Name</TableCell>
            <TableCell align="left">Expires</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invitations.length < 1 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <NoRowsPlaceholder>No Pending Invitations</NoRowsPlaceholder>
              </TableCell>
            </TableRow>
          )}
          {invitations.map((invitation: UserEntityMemberInvitation) => (
            <TableRow key={invitation.id?.value}>
              <TableCell align="left">
                <Typography className="invitation-id">{invitation.id?.value ?? ""}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography className="invitation-entity">{invitation.registrationInfo.email?.value ?? ""}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>{invitation.userEntityInfo.entityName.value}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>{invitation.expires?.format("MM/DD/YY") ?? <Remove />}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </InvitationsTable>
  );
}
